import {
    DispatchDateRoute
  } from '../../../../../core';

  export const dispatchDateRoute = {
    searchText: 'Buscar rutas',
    addText: '',
    export: false,
    filter: false,
    filterDefault: '',
    checkbox: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Origen',
        name: 'origin',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: DispatchDateRoute) => element.origin.entityName
      },
      {
        title: 'Destino',
        name: 'destiny',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: DispatchDateRoute) =>
          element.entity ? element.entity.entityName : element.zone.name
      },
      {
        title: 'Tipo',
        name: 'type',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: DispatchDateRoute) => (element.entity ? 'Entidad' : 'Zona')
      },
      {
        title: 'Tiempo de viaje',
        name: 'time',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: DispatchDateRoute) => element.time
      },
      {
        title: 'Tipo de despacho',
        name: 'name',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: DispatchDateRoute) => element.name
      },
      {
        title: 'Activo',
        name: 'allowDispatch',
        type: 'boolean',
        editable: true,
        toggleValue: () => true,
        checkAll: true,
        class: 'center',
        value: (element: DispatchDateRoute) => element.allowDispatch
      }
    ],
    subTable: {}
  };
